<template>
	<div id="head">
		<div class="head_con w-1440">
			<router-link to="/" class="logo">
				<img src="@/assets/images/logo.jpg" alt="" />
			</router-link>
			<div class="sear posi_r d-flex">
				<div class="sear_btn" @click="toSearch"></div>
				<input type="text" v-model="search_name" class="inp flex-1" placeholder="请输入搜索关键字" />
				<div class="btn d-flex a-center" @mouseleave="subShow=false" @click="toSearch">
					<img src="@/assets/images/jt_down.jpg" @mouseover="subShow=true" />
					<span>{{searchLm}}</span>

					<div class="sub_con" v-if="subShow">
						<p @click.stop="btnClick(1,'政策法规')">政策法规</p>
						<p @click.stop="btnClick(2,'农资服务')">农资服务</p>
						<p @click.stop="btnClick(3,'农机服务')">农机服务</p>
						<p @click.stop="btnClick(4,'农技服务')">农技服务</p>
						<p @click.stop="btnClick(5,'金融服务')">金融服务</p>
						<p @click.stop="btnClick(6,'特色农产品')">特色农产品</p>
						<p @click.stop="btnClick(7,'新型经营主体')">新型经营主体</p>
					</div>
				</div>


			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "head_con",
		data() {
			return {
				times: '',
				huanyingyu: '',
				search_name: '',
				subShow: false,
				searchLm: '政策法规',
				searchLmId: 1,
				searchx: ['', '政策法规', '农资服务', '农机服务', '农技服务', '金融服务', '特色农产品', '新型经营主体']

			}
		},
		mounted(e) {
			this.search_name = this.$route.query.search_name
			this.searchLmId = this.$route.query.type
			if (this.$route.query.type) {
				this.searchLm = this.searchx[this.$route.query.type]
			}
		},
		methods: {
			toSearch(e) {
				if (!this.search_name) {
					this.$toast('请输入搜索关键字');
					return
				}
				var path = '/policy'
				if (this.searchLmId == 1) {
					path = '/policy'
				} else if (this.searchLmId == 2) {
					path = '/nongzi'
				} else if (this.searchLmId == 3) {
					path = '/nongji'
				} else if (this.searchLmId == 4) {
					path = '/talent'
				} else if (this.searchLmId == 5) {
					path = '/financial'
				} else if (this.searchLmId == 6) {
					path = '/feature'
				} else if (this.searchLmId == 7) {
					path = '/modern'
				}
				this.$router.push({
					path: path,
					query: {
						search_name: this.search_name,
						type: this.searchLmId
					}
				})
			},
			btnClick(e, item = '') {
				this.searchLm = item
				this.subShow = false
				this.searchLmId = e

			}
		}
	}
</script>

<style lang="scss" scoped>
	#head {
		background: #fff;

		.head_con {
			height: 84px;
			padding: 24px 0 0;
			position: relative;
			z-index: 100;

			.logo {
				display: block;
				width: 550px;
				height: 60px;
				float: left;
			}

			.back_ind {
				position: absolute;
				left: 580px;
				top: 50px;
				color: #333;
				font-size: 16px;
				text-decoration: underline;
			}

			.sear {
				float: right;
				width: 590px;
				height: 56px;
				background: #eaf5f1;
				border-radius: 5px;
				z-index: 100;

				.sear_btn {
					width: 60px;
					height: 56px;
					position: absolute;
					left: 0;
					top: 0;
					cursor: pointer;
				}

				.btn {
					width: 172px;
					height: 56px;
					background: #389523;
					padding-left: 24px;
					box-sizing: border-box;
					font-size: 18px;
					color: #fff;
					cursor: pointer;
					border-radius: 0 5px 5px 0;

					img {
						margin-right: 10px;
					}
				}

				.inp {
					border: none;
					background: none;
					font-size: 18px;
					height: 56px;
					line-height: 56px;
					color: #333;
					background: url('../../assets/images/sear_ico.jpg') 10px center no-repeat;
					padding-left: 60px;

					outline: none;
				}

				.sub_con {
					position: absolute;
					right: 0;
					top: 100%;
					background: #fff;
					z-index: 101;
					width: 170px;
					border: #389523 solid 1px;

					p {
						cursor: pointer;
						line-height: 50px;
						font-size: 18px;
						color: #333;
						text-align: center;
						border-bottom: #eaf5f1 solid 1px;

						&:hover {
							background-color: #389523;
							color: #fff;
						}
					}
				}
			}
		}
	}
</style>